import React from 'react';

const Col6FormCheck = ({ children }) => {
  return (
    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pl-5 pt-3">
      <div className="form-check">{children}</div>
    </div>
  );
};

export default Col6FormCheck;
